import { render, staticRenderFns } from "./OrderTabs.vue?vue&type=template&id=63557f01&scoped=true&"
import script from "./OrderTabs.vue?vue&type=script&lang=js&"
export * from "./OrderTabs.vue?vue&type=script&lang=js&"
import style0 from "./OrderTabs.vue?vue&type=style&index=0&id=63557f01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63557f01",
  null
  
)

export default component.exports